import { useContext, useEffect } from "react";
import { Link, useParams, useNavigate } from "react-router-dom";
import Header from "../../components/Header";
import { LocaleParams } from "../../types";
import { Product } from "@cocunat/ui-components";
import { MainContext } from "../../context/main";

function Gallery() {
  const { lang, country } = useParams<LocaleParams>();
  const { products } = useContext(MainContext);
  let navigate = useNavigate();

  const QUIZ_URL = `/${lang}-${country}/quizz/1/`;

  useEffect(() => {
    navigate(QUIZ_URL);
  }, []);
  return (
    <div>
      <Header />
      <div className="container">
        <h1>Gallery</h1>
        <Link to={`/${lang}-${country}/quizz/1/`}>
          <button>Go to Quizz</button>
        </Link>
        <div className="row">
          {products &&
            products.categories &&
            products.categories[65].map((product: any) => (
              <div className="col-md-3 col-sm-6 col-xs-6">
                <Product
                  key={product.id}
                  data={product}
                  to={"https://cocunat.com/product/" + product.translation.slug}
                />
              </div>
            ))}
        </div>
      </div>
    </div>
  );
}

export default Gallery;
